<template>
<div style="padding-top:1px;margin-right:20px;" title="Perfil">
  <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none" right  no-caret>
    <template v-slot:button-content style="color: #72777a!important;">
        <i class="fas fa-user" style="color: #72777a!important;"></i>
        <span style="margin-left:10px;color: #72777a!important;"> {{ actualUser.email }} </span>
    </template>
    <b-dropdown-item :to="{ name: 'profile'}">Mi cuenta</b-dropdown-item>
    <!--<b-dropdown-item :to="{ name: 'messages'}">Mensajes</b-dropdown-item>-->
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item :to="{ name: 'logout'}">Cerrar sesión</b-dropdown-item>
  </b-dropdown>
</div>
</template>

<script>
export default {
  data () {
    return {
      actualUser: JSON.parse(localStorage.getItem('user'))
    }
  },
  mounted(){    
    this.actualUser = JSON.parse(localStorage.getItem('user'));
  }
}
</script>
